import { Box, Typography, Link, Button, Stack, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { VERSION } from '@/version.ts';

type FooterProps = {
  path?: string;
};

function Footer({ path }: FooterProps) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('landing-page');

  const language = i18n.language;

  return (
    <Stack
      data-cy="footer"
      gap={2}
      direction={{ xs: 'column-reverse', md: 'row' }}
      sx={{
        py: '28px',
        px: '20px',
        position: 'relative',
        justifyContent: { xs: 'start', md: 'space-between' },
        marginTop: '60px',
        backgroundColor: '#000000'
      }}
    >
      {path === 'imprint' && (
        <Box sx={{ position: 'absolute', top: 0, left: 2, marginTop: '-16px' }}>
          <Typography fontFamily="Montserrat" fontSize="10px">
            Version: {VERSION}
          </Typography>
        </Box>
      )}
      <Box>
        <Stack direction={{ xs: 'column', md: 'row' }} gap={{ xs: 0, md: 1 }}>
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontWeight: 800,
              color: '#FFFFFF'
            }}
          >
            {t('footer.copy-right')}
          </Typography>
          <Stack direction="row" gap={1}>
            <Link
              href={t('footer.link.telephone')}
              underline="hover"
              sx={{
                fontFamily: 'Montserrat',
                fontSize: '15px',
                color: '#FFFFFF',
                padding: '2px 4px',
                display: 'inline-block'
              }}
            >
              {t('footer.telephone')}
            </Link>
            <Typography
              sx={{
                fontFamily: 'Montserrat',
                fontSize: '15px',
                color: '#FFFFFF',
                padding: '2px 4px',
                display: 'inline-block'
              }}
            >
              •
            </Typography>
            <Link
              href={t('footer.link.email')}
              underline="hover"
              sx={{
                fontFamily: 'Montserrat',
                fontSize: '15px',
                color: '#FFFFFF',
                padding: '2px 4px',
                display: 'inline-block'
              }}
            >
              {t('footer.email')}
            </Link>
          </Stack>
        </Stack>
        <Stack gap={1} direction="row">
          <Link
            href={`${language === 'de-CH' ? '/de' : '/fr'}/imprint`}
            onClick={(e) => {
              e.preventDefault();
              navigate(language === 'de-CH' ? '/de/imprint' : '/fr/imprint');
            }}
            underline="hover"
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '15px',
              color: '#FFFFFF',
              padding: '2px 4px',
              display: 'inline-block'
            }}
          >
            {t('footer.legal-notice')}
          </Link>
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '15px',
              color: '#FFFFFF'
            }}
          >
            •
          </Typography>
          <Link
            href={t('footer.link.terms-and-conditions')}
            target="_blank"
            underline="hover"
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '15px',
              color: '#FFFFFF',
              padding: '2px 4px',
              display: 'inline-block'
            }}
          >
            {t('footer.terms-and-conditions')}
          </Link>
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '15px',
              color: '#FFFFFF'
            }}
          >
            •
          </Typography>
          <Link
            href={t('footer.link.privacy-policy')}
            target="_blank"
            underline="hover"
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '15px',
              color: '#FFFFFF',
              padding: '2px 4px',
              display: 'inline-block'
            }}
          >
            {t('footer.privacy-policy')}
          </Link>
        </Stack>
      </Box>
      <Stack direction="row" gap={2}>
        <Button
          href="https://www.waermecheck.ch/"
          sx={{
            fontFamily: 'Montserrat',
            fontWeight: 600,
            fontSize: '15px',
            color: '#FFFFFF'
          }}
        >
          {t('footer.language.de')}
        </Button>
        <Divider orientation="vertical" flexItem sx={{ backgroundColor: '#FFFFFF', my: 1 }} />
        <Button
          href="https://www.check-chaleur.ch/"
          sx={{
            fontFamily: 'Montserrat',
            fontWeight: 600,
            fontSize: '15px',
            color: '#FFFFFF'
          }}
        >
          {t('footer.language.fr')}
        </Button>
      </Stack>
    </Stack>
  );
}

export default Footer;
